import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import * as i2 from 'reference-library';
import * as i3 from '@ngrx/store';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/radiobutton';
import * as i6 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';

class CustomFormRadioButtonService {
    constructor() { }
}
CustomFormRadioButtonService.ɵfac = function CustomFormRadioButtonService_Factory(t) { return new (t || CustomFormRadioButtonService)(); };
CustomFormRadioButtonService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomFormRadioButtonService, factory: CustomFormRadioButtonService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomFormRadioButtonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class TruncatePipe {
    transform(value, limit) {
        return value.length < limit
            ? value
            : value.slice(0, limit) + '..';
    }
}
TruncatePipe.ɵfac = function TruncatePipe_Factory(t) { return new (t || TruncatePipe)(); };
TruncatePipe.ɵpipe = i0.ɵɵdefinePipe({ name: "truncate", type: TruncatePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncatePipe, [{
        type: Pipe,
        args: [{ name: 'truncate' }]
    }], null, null); })();

function CustomFormRadioButtonComponent_em_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 2);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "color": a0 }; };
function CustomFormRadioButtonComponent_div_1_div_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "truncate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("pTooltip", (item_r5 == null ? null : item_r5.name == null ? null : item_r5.name.length) > 12 ? item_r5 == null ? null : item_r5.name : "")("ngStyle", i0.ɵɵpureFunction1(6, _c0, item_r5.name == ctx_r7.selectedItem ? "#fff" : "#000"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 3, item_r5 == null ? null : item_r5.name, 10));
} }
function CustomFormRadioButtonComponent_div_1_div_1_div_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0, item_r5.name == ctx_r9.selectedItem ? "#fff" : "#000"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", item_r5 == null ? null : item_r5.name, " ");
} }
const _c1 = function (a0) { return { "background-color": a0 }; };
function CustomFormRadioButtonComponent_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "p-radioButton", 8);
    i0.ɵɵlistener("onClick", function CustomFormRadioButtonComponent_div_1_div_1_div_1_Template_p_radioButton_onClick_1_listener() { i0.ɵɵrestoreView(_r13); const item_r5 = ctx.$implicit; const ctx_r12 = i0.ɵɵnextContext(3); return ctx_r12.setParentGroup(item_r5, "inputArray"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵelement(4, "img", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomFormRadioButtonComponent_div_1_div_1_div_1_div_5_Template, 3, 8, "div", 12);
    i0.ɵɵtemplate(6, CustomFormRadioButtonComponent_div_1_div_1_div_1_ng_template_6_Template, 2, 4, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const _r8 = i0.ɵɵreference(7);
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputId", item_r5.code)("name", ctx_r3.formControlName)("value", item_r5.name)("formControlName", ctx_r3.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", item_r5.code)("ngStyle", i0.ɵɵpureFunction1(9, _c1, item_r5.name == ctx_r3.selectedItem ? "rgb(72 168 245)" : "rgb(215 231 244)"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", item_r5.imgUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (item_r5 == null ? null : item_r5.name == null ? null : item_r5.name.length) > 12)("ngIfElse", _r8);
} }
function CustomFormRadioButtonComponent_div_1_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomFormRadioButtonComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomFormRadioButtonComponent_div_1_div_1_div_1_Template, 8, 11, "div", 5);
    i0.ɵɵtemplate(2, CustomFormRadioButtonComponent_div_1_div_1_span_2_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.inputParams.properties.inputArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.inputParams == null ? null : ctx_r2.inputParams.mandatory) && ctx_r2.group.get(ctx_r2.formControlName).touched && !ctx_r2.hasValue);
} }
const _c2 = function (a0) { return { "width": a0 }; };
function CustomFormRadioButtonComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, CustomFormRadioButtonComponent_div_1_div_1_Template, 3, 2, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(4, _c2, ctx_r1.inputParams == null ? null : ctx_r1.inputParams.style == null ? null : ctx_r1.inputParams.style.width));
    i0.ɵɵproperty("formGroup", ctx_r1.childGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams.properties.inputArray.length > 0);
} }
class CustomFormRadioButtonComponent {
    constructor(fb, referenceLibraryService, store) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.store = store;
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value, [this.requiredValidator.bind(this)]));
        this.selectedItem = this.inputParams.value;
        if (this.inputParams.properties && this.inputParams.properties.isDataFromApi &&
            this.inputParams.properties.refercenceCodeForApiCall != '') {
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value.code : null, [this.requiredValidator.bind(this)])
            });
            this.referenceLibraryService.getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.refDataArr = response;
                if (this.refDataArr.length > 0) {
                    this.inputParams.properties.inputArray = this.refDataArr.map(x => {
                        if (typeof x === 'string') {
                            return {
                                code: this.uuid(),
                                name: x
                            };
                        }
                        else if (typeof x === 'object') {
                            return Object.assign(Object.assign({}, x), { imgUrl: '/assets/userIcon.png', custId: null });
                        }
                    });
                }
                this.refDataArr = [];
            });
        }
        else {
            if (this.inputParams.properties.inputArray && this.inputParams.properties.inputArray.length > 0) {
                this.inputParams.properties.inputArray = this.inputParams.properties.inputArray.map(x => {
                    if (typeof x === 'string') {
                        return {
                            code: this.uuid(),
                            name: x
                        };
                    }
                    else if (typeof x === 'object') {
                        return Object.assign(Object.assign({}, x), { code: x.data_field_name ? x.data_field_name : this.uuid() });
                    }
                });
            }
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value : null, [this.requiredValidator.bind(this)])
            });
            // console.log(this.childGroup, this.childGroup.get(this.formControlName));
            this.refDataArr = [];
        }
        this.childGroup.get(this.formControlName).valueChanges
            .pipe(map(value => !!value))
            .subscribe(hasValue => {
            this.hasValue = hasValue;
        });
    }
    requiredValidator(control) {
        const currentValue = control.value;
        if (Array.isArray(currentValue) && this.inputParams.mandatory === true) {
            return { 'required': true };
        }
        return null;
    }
    uuid() {
        const val1 = Date.now().toString(36);
        const val2 = Math.random().toString(36).substring(2);
        return val1 + val2;
    }
    ngOnChanges(changes) {
        if (changes.group && changes.inputParams && changes.formControlName) {
            this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value));
            if (this.inputParams.properties && this.inputParams.properties.isDataFromApi &&
                this.inputParams.properties.refercenceCodeForApiCall != '') {
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value.code : null)
                });
                this.referenceLibraryService.getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    this.refDataArr = response;
                    if (this.refDataArr.length > 0) {
                        this.inputParams.properties.inputArray = this.refDataArr.map(x => {
                            if (typeof x === 'string') {
                                return {
                                    code: this.uuid(),
                                    name: x
                                };
                            }
                            else if (typeof x === 'object') {
                                return Object.assign(Object.assign({}, x), { imgUrl: '/assets/userIcon.png', custId: null });
                            }
                        });
                    }
                    this.refDataArr = [];
                });
            }
            else {
                if (this.inputParams.properties.inputArray && this.inputParams.properties.inputArray.length > 0) {
                    this.inputParams.properties.inputArray = this.inputParams.properties.inputArray.map(x => {
                        if (typeof x === 'string') {
                            return {
                                code: this.uuid(),
                                name: x
                            };
                        }
                        else if (typeof x === 'object') {
                            return Object.assign(Object.assign({}, x), { code: x.data_field_name ? x.data_field_name : this.uuid() });
                        }
                    });
                }
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(this.inputParams.value ? this.inputParams.value : null)
                });
                this.refDataArr = [];
            }
        }
        this.disableAfterSubmitAndSave();
    }
    setParentGroup(item, arrayName) {
        this.selectedItem = item.name;
        this.group.get([this.formControlName]).patchValue(item);
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    disableAfterSubmitAndSave() {
        this.userType = sessionStorage.getItem('userTypeRole');
        if (((this.userType === 'Petitioner' || this.userType === 'Attorney') && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'NEW')) || (this.userType === 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode === 'SUBMIT' || this.inputData.stepStatusCode === 'NEW'))) {
            this.childGroup.disable();
            this.group.disable();
        }
        else {
            this.childGroup.enable();
            this.group.enable();
        }
    }
}
CustomFormRadioButtonComponent.ɵfac = function CustomFormRadioButtonComponent_Factory(t) { return new (t || CustomFormRadioButtonComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.Store)); };
CustomFormRadioButtonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomFormRadioButtonComponent, selectors: [["lib-custom-form-radio-button"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group", inputData: "inputData", stepDetails: "stepDetails" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "error-indicator", 4, "ngIf"], ["class", "form-group mt-3", 3, "formGroup", "style", 4, "ngIf"], [1, "error-indicator"], [1, "form-group", "mt-3", 3, "formGroup"], [4, "ngIf"], ["class", "p-field-checkbox customRadioButton", 4, "ngFor", "ngForOf"], ["class", "error", 4, "ngIf"], [1, "p-field-checkbox", "customRadioButton"], [1, "customRadio", 3, "inputId", "name", "value", "formControlName", "onClick"], [1, "label-cls", "customLabel", 3, "for", "ngStyle"], [1, "customImg"], ["alt", "", 1, "customImgSub", 3, "src"], ["class", "customName", 3, "pTooltip", "ngStyle", 4, "ngIf", "ngIfElse"], ["nonTruncates", ""], [1, "customName", 3, "pTooltip", "ngStyle"], [1, "customName", 3, "ngStyle"], [1, "error"]], template: function CustomFormRadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomFormRadioButtonComponent_em_0_Template, 2, 0, "em", 0);
        i0.ɵɵtemplate(1, CustomFormRadioButtonComponent_div_1_Template, 2, 6, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.childGroup && ctx.childGroup.get(ctx.formControlName));
    } }, directives: [i4.NgIf, i1.NgControlStatusGroup, i1.FormGroupDirective, i4.NgForOf, i5.RadioButton, i1.NgControlStatus, i1.FormControlName, i4.NgStyle, i6.Tooltip], pipes: [TruncatePipe], styles: [".p-field-checkbox[_ngcontent-%COMP%]{display:contents}.customRadioButton[_ngcontent-%COMP%]{position:relative;display:contents;float:left;text-align:left;justify-content:space-between;margin-right:25px;padding:5px}.customRadio[_ngcontent-%COMP%]{position:absolute;z-index:-1;left:25px;top:25%}.customLabel[_ngcontent-%COMP%]{padding:10px 20px;border-radius:6px;text-align:center;margin-top:0;margin-bottom:25px!important;margin-right:25px;cursor:pointer}.customImg[_ngcontent-%COMP%], .customImgSub[_ngcontent-%COMP%]{width:100%;height:45px}.customName[_ngcontent-%COMP%]{width:5.5rem;padding-top:.4rem;text-transform:capitalize}.error[_ngcontent-%COMP%]{position:relative;top:36px;right:80px}.error[_ngcontent-%COMP%], .error-indicator[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.error-indicator[_ngcontent-%COMP%]{position:absolute;bottom:148px;left:102px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomFormRadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-form-radio-button',
                templateUrl: 'custom-form-radio-button.component.html',
                styleUrls: ['custom-form-radio-button.component.scss'
                ]
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: i3.Store }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], inputData: [{
            type: Input
        }], stepDetails: [{
            type: Input
        }] }); })();

class CustomFormRadioButtonModule {
}
CustomFormRadioButtonModule.ɵfac = function CustomFormRadioButtonModule_Factory(t) { return new (t || CustomFormRadioButtonModule)(); };
CustomFormRadioButtonModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomFormRadioButtonModule });
CustomFormRadioButtonModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomFormRadioButtonModule, { declarations: [CustomFormRadioButtonComponent, TruncatePipe], imports: [ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomFormRadioButtonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomFormRadioButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomFormRadioButtonComponent, TruncatePipe],
                imports: [
                    ReactiveFormsModule,
                    PrimengLibraryModule
                ],
                exports: [CustomFormRadioButtonComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-form-radio-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomFormRadioButtonComponent, CustomFormRadioButtonModule, CustomFormRadioButtonService };
//# sourceMappingURL=custom-form-radio-button.js.map
